import { Component, computed, effect, input, InputSignal, Signal, untracked } from '@angular/core';
import { CommonModule } from '@angular/common';
import { createActionListNoRules, IqWorkflowActionProcessorService } from '@dat/iq-workflow';
import { IqRateLaneUtilsStateService } from '../state';
import { IDatiqRulesData, IDatiqAction } from '@dat/iq-proxy';

@Component({
    selector: 'iq-rate-lane-utils-rate-loader',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-rate-lane-utils-rate-loader.component.html',
    styleUrl: './iq-rate-lane-utils-rate-loader.component.scss',
})
export class IqRateLaneUtilsRateLoaderComponent {
    dashboardId: InputSignal<string> = input('');
    equipmentType: InputSignal<string> = input('');
    rateType: InputSignal<string> = input('');
    origin: InputSignal<string> = input('');
    destination: InputSignal<string> = input('');

    rate: Signal<Promise<number>> = computed(async () => {
        return await this._state.getRates(
            this.equipmentType(),
            this.rateType(),
            this.origin(),
            this.destination()
        );
    });

    constructor(
        private readonly _actions: IqWorkflowActionProcessorService,
        private readonly _state: IqRateLaneUtilsStateService
    ) {
        effect(async () => {
            const rate = await this.rate();

            untracked(async () => {
                this.updateRatePerMile(rate);
            })
        })
    }

    updateRatePerMile(rate: number) {
        const actions: IDatiqRulesData<IDatiqAction>[] = 
            createActionListNoRules([
                {
                    name: 'updateDashboardCache',
                    payload: {
                        id: this.dashboardId(),
                        data: {
                            ratePerMile: rate,
                        },
                    },
                },
                {
                    name: 'setDashboardControlValue',
                    payload: {
                        dashboardControlId: 'rv-quote-calc',
                        controlName: 'ratePerMile',
                        value: '<%- rate %>'
                    }
                }
            ]);
        this._actions.processActions(actions, { rate });
    }
}
